<!-- Small, quiet "Beta" label used next to feature names. Keep one style for
     every beta marker in the app so they read as a system label. -->
<span class="ml-1 px-1 py-px text-[9px] font-semibold uppercase tracking-wider rounded border border-gray-300 dark:border-gray-600 text-gray-400 dark:text-gray-500 align-middle">Beta</span>
